import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";
import { routes } from "@/routes/utils";
import { useNavigate } from "react-router-dom";
import { useGetProjectCategories } from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useCategory = () => {
  const isMobile = useIsMobile();
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate();

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const { data: projectCategoryList, isLoading: isLoadingProjectCategory } =
    useGetProjectCategories({ tenantId: loggedInUserData?.tenantId });

  // Define Table Columns
  const columns = [
    {
      accessorKey: "projectCategoryId",
      header: "ID",
      accessorFn: (row: any) => String(row?.projectCategoryId || ""),
    },
    {
      accessorKey: "catName",
      header: "Category Name",
      accessorFn: (row: any) => String(row?.catName || ""),
    },
    {
      accessorKey: "catDescription",
      header: "Description",
      accessorFn: (row: any) => String(row?.catDescription || ""),
    },
  ];

  const onAdd = () => {
    navigate(`${routes.add}`);
  };

  return {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    projectCategoryList,
    isLoadingProjectCategory,
  };
};
export default useCategory;
